import { Component} from '@angular/core';


@Component({
  selector: 'app-optical-module',
  templateUrl: './optical-module.component.html',
  styleUrls: ['./optical-module.component.scss']
})
export class OpticalModuleComponent {

  isFavorite: boolean = true;
  public mini = true;
  sidePanelOver: boolean = false;
  arrowfirst:boolean=true;
  arrowSecond:boolean=false;
  over(){
    if(this.sidePanelOver ==false){
      if (this.mini)  {
        this.isFavorite =false;
          document.getElementById("mySidebar").style.width = "175px";
          this.mini = false;
          document.body.classList.add('expanded');
        } else {
          document.getElementById("mySidebar").style.width = "50px";
          this.mini = true;
          this.isFavorite =true; 
          document.body.classList.remove('expanded');
        }
    }
   
  }

 
  toggleSidebar() {
  
    if (this.mini) {
      this.sidePanelOver =true;
      this.arrowSecond =true;
      this.arrowfirst =false;
    //   console.log("opening sidebar");
    this.isFavorite =false;
      document.getElementById("mySidebar").style.width = "175px";
      // document.getElementById("main").style.marginLeft = "195px";
      this.mini = false;
      document.body.classList.add('expanded');
    } else {
    //   console.log("closing sidebar");
      document.getElementById("mySidebar").style.width = "50px";
      // document.getElementById("main").style.marginLeft = "70px";
      this.arrowSecond =false;
      this.arrowfirst =true;
      this.mini = true;
      this.isFavorite =true; 
      this.sidePanelOver =false;
      document.body.classList.remove('expanded');
    }
  }

}
